import React from 'react';

const MessageModal = ({ isOpen, title, message, type = 'info', onClose }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  // Determine icon and color based on type
  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          iconColor: '#22c55e',
          icon: '', // Remove the checkmark icon
          titleColor: '#16a34a'
        };
      case 'error':
        return {
          iconColor: '#ef4444',
          icon: '⚠',
          titleColor: '#dc2626'
        };
      default:
        return {
          iconColor: 'var(--color1)',
          icon: 'ℹ',
          titleColor: 'var(--color1)'
        };
    }
  };

  const typeStyles = getTypeStyles();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: 'var(--standard-box-shadow)',
        minWidth: '400px',
        maxWidth: '500px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '24px',
          color: typeStyles.iconColor,
          marginBottom: typeStyles.icon ? '12px' : '0' // No margin if no icon
        }}>
          {typeStyles.icon}
        </div>
        
        {type !== 'success' && (
          <h3 style={{
            margin: '0 0 16px 0',
            fontSize: '20px', // Increased from 18px
            fontWeight: '600',
            color: typeStyles.titleColor
          }}>
            {title}
          </h3>
        )}
        
        <p style={{
          margin: '0 0 20px 0',
          fontSize: '16px', // Increased from 14px
          color: 'var(--text-color)',
          lineHeight: '1.4'
        }}>
          {message}
        </p>
        
        <button
          onClick={onClose}
          onKeyDown={handleKeyPress}
          autoFocus
          style={{
            padding: '10px 20px',
            backgroundColor: 'var(--color1)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
